<template>
  <div class="Signature">
    <div class="flex-jc-start">
      <div :style="{width: leftWidth+ 'px'}" class="pd-r-20 signature-left text-right">
        <p>{{ personal.fullName }}</p>
        <p>{{ personal.lastName }}</p>
        <p>{{ personal.city?.name }} <i v-if="!!personal.city?.name">,</i>{{ personal.country?.name }}</p>
        <!--        <br> -->
        <p>Mob: <span v-if="personal.mobileCode">{{ personal.mobileCode }}</span>{{ personal.mobileNo }}</p>
        <p>Skype: {{ personal.skype ? personal.skype : 'NIL' }}</p>
        <p>E-Mail: {{ personal?.emails?.length > 0 ? personal.emails[0] : '' }}</p>
        <div v-if="personal?.emails?.length >1">
          <p v-for=" em in personal.emails.slice(1)">
            {{ em }}
          </p>
        </div>
      </div>
      <div class="flex-1 signature-right">
        <p>{{ department.name }}【{{ department?.address?.city || department?.city?.name }} <i v-if="!!department?.address?.city || department?.city?.name">,</i> {{ department?.address?.country || department?.country?.name }}】</p>
        <div>
          <p>{{ subCom.name }}</p>
          <p>Address: {{ subCom.regAddress }}</p>
        </div>

        <div>
          <p>Head/Group Name: {{ masterCom.name }}</p>
          <p>{{ masterCom.regCity?.name }} <i v-if="!!masterCom.regCity?.name">,</i>{{ masterCom.regCountry?.name }}</p>
        </div>
      </div>
    </div>
    <div class="flex-jc-start">
      <div :style="{width: leftWidth+ 'px'}" class="pd-r-20 signature-left text-right">
        <img v-if="personal?.avatar" :src="personal.avatar" style="width: 45px; margin-top: 56px" alt="">
      </div>
      <div class="flex-1 signature-right">
        <p>E-mail: {{ department.emails }}</p>
        <p>TEL(REP): {{ department.telRep }}</p>
        <P>TEL(DIR): {{ department.telDir }} </P>
        <P>Fax: {{ department.fax }}</P>
        <p>Skype: {{ department.skype ? department.skype : 'NIL' }}</p>
        <p>Website: {{ subCom.website || masterCom.website }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import { useStore } from 'vuex'
import { reactive } from 'vue'

export default {
  name: 'BusinessCard',
  props: {
    leftWidth: {
      type: Number,
      default: 240
    },

    isUser: {
      type: Boolean,
      default: false
    },

    per: {
      type: Object,
      default () {
        return {}
      }
    },

    dept: {
      type: Object,
      default () {
        return {}
      }
    },

    sCom: {
      type: Object,
      default () {
        return {}
      }
    },

    mCom: {
      type: Object,
      default () {
        return {}
      }
    }

  },

  setup (props, ctx) {
    const personal = reactive({})
    const department = reactive({})
    const subCom = reactive({})
    const masterCom = reactive({})
    if (props.isUser) {
      const store = useStore()
      const user = store.state.user.user
      user.emails = user.emails.split(';')
      if (user.avatar instanceof Object) {
        user.avatar = Object.values(personal?.avatar)[0]
      }
      Object.assign(personal, user)
      if (user.affiliation) {
        Object.assign(department, user.affiliation.dept)
        Object.assign(subCom, user.affiliation.subNode.defaultCorp)
        Object.assign(masterCom, user.affiliation.masterNode.defaultCorp)
      }
    } else {
      Object.assign(personal, props.per)
      Object.assign(department, props.dept)
      Object.assign(subCom, props.sCom)
      Object.assign(masterCom, props.mCom)
    }
    return {
      personal,
      department,
      subCom,
      masterCom
    }
  }
}
</script>

<style scoped lang="less">
.Signature{
  font-size: 14px;
  .signature-left{
    color: #676767;
    p {
      margin: 5px 0;
    }

  }
  .signature-right{
    p {
      margin: 5px 0;
    }

  }
  //css、less
}
</style>
